import axios from 'axios';

const apiConfig = axios.create({
  headers: {
    'Content-Type': 'application/json'
    },
});
export default apiConfig;
